import React from 'react';
export const PricingSection = () => {
  return <section className="mb-12" data-id="element-205">
      <h2 className="text-2xl font-bold text-blue-900 mb-6 text-center" data-id="element-206">
        The Economics That Will Shock You
      </h2>
      <div className="flex flex-col md:flex-row gap-8 mb-8" data-id="element-207">
        <div className="md:w-1/2 bg-red-50 p-6 rounded-lg shadow" data-id="element-208">
          <h3 className="text-xl font-bold text-red-700 mb-4 text-center" data-id="element-209">
            Traditional Anti-Aging Approach
          </h3>
          <p className="text-gray-700 mb-4 text-center font-semibold" data-id="element-210">
            (Annual Costs)
          </p>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-211">
            <li data-id="element-212">Botox treatments (3-4x/year): £900-1,500</li>
            <li data-id="element-213">Dermal fillers (1-2x/year): £600-1,125</li>
            <li data-id="element-214">Professional skin care: £900-1,800</li>
            <li data-id="element-215">Laser treatments: £750-2,250</li>
            <li data-id="element-216">Chemical peels: £450-900</li>
          </ul>
          <div className="bg-white p-3 rounded-lg mb-4" data-id="element-217">
            <p className="font-bold text-red-700 text-center" data-id="element-218">
              Total: £3,600-7,575 per year
            </p>
          </div>
          <p className="font-bold text-red-800 text-center" data-id="element-219">
            10-year cost: £36,000 - £75,750
          </p>
        </div>
        <div className="md:w-1/2 bg-green-50 p-6 rounded-lg shadow" data-id="element-220">
          <h3 className="text-xl font-bold text-green-700 mb-4 text-center" data-id="element-221">
            Silk Pillowcase Prevention Approach
          </h3>
          <ul className="list-disc pl-6 text-gray-700 space-y-2 mb-4" data-id="element-222">
            <li data-id="element-223">Premium Mulberry silk pillowcase: £59</li>
            <li data-id="element-224">Replacement every 2-3 years: £59</li>
          </ul>
          <div className="bg-white p-3 rounded-lg mb-4" data-id="element-225">
            <p className="font-bold text-green-700 text-center" data-id="element-226">
              Total 10-year cost: £200-267
            </p>
          </div>
          <p className="font-bold text-green-800 text-center" data-id="element-227">
            Savings: £35,800 - £75,500 over 10 years
          </p>
        </div>
      </div>
      <div className="w-full flex justify-center mb-8" data-id="element-228">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qP9FKpPCud6uuCCj9vHU1u/velourabedimage.png" alt="Elegant Veloura silk pillowcases in blush pink and neutral tones arranged on a luxurious bed with decorative flowers" className="rounded-lg shadow-lg max-w-full md:max-w-2xl" data-id="element-229" />
      </div>
      <div className="bg-blue-50 p-6 rounded-lg mb-8" data-id="element-230">
        <h3 className="text-xl font-bold text-blue-900 mb-4" data-id="element-231">
          The Treatment Trap Economics
        </h3>
        <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2 mb-6" data-id="element-232">
          "Here's what really opened my eyes," Dr. Grant explains. "My patients
          who started using silk pillowcases began spacing out their
          treatments."
        </blockquote>
        <div className="flex flex-col md:flex-row gap-4 mb-6" data-id="element-233">
          <div className="md:w-1/2 bg-white p-4 rounded-lg shadow-sm" data-id="element-234">
            <p className="font-semibold text-gray-700 text-center" data-id="element-235">
              Before Silk:
            </p>
            <p className="font-bold text-red-700 text-center text-xl" data-id="element-236">
              Average patient spent £5,100/year on treatments
            </p>
          </div>
          <div className="md:w-1/2 bg-white p-4 rounded-lg shadow-sm" data-id="element-237">
            <p className="font-semibold text-gray-700 text-center" data-id="element-238">
              After Silk:
            </p>
            <p className="font-bold text-green-700 text-center text-xl" data-id="element-239">
              Same patients spent £1,800/year on treatments
            </p>
          </div>
        </div>
        <blockquote className="italic text-gray-700 border-l-4 border-blue-900 pl-4 py-2" data-id="element-240">
          "They were getting better results while spending less money. That's
          when I understood why the industry wants to keep this quiet."
        </blockquote>
      </div>
      <div className="bg-blue-900 text-white p-6 rounded-lg" data-id="element-241">
        <h3 className="text-xl font-bold mb-4 text-center" data-id="element-242">
          Investment vs. Expense Mindset
        </h3>
        <blockquote className="italic border-l-4 border-white pl-4 py-2 mb-6" data-id="element-243">
          "This isn't a purchase—it's an investment with compound returns," Dr.
          Grant explains. "Every night you use silk, you're preventing damage
          that would cost thousands to reverse later."
        </blockquote>
        <h4 className="font-bold mb-2 text-center" data-id="element-244">
          Return on Investment Calculation:
        </h4>
        <div className="grid grid-cols-3 gap-4 mb-6" data-id="element-245">
          <div className="bg-blue-800 p-3 rounded-lg text-center" data-id="element-246">
            <p className="font-semibold text-sm mb-1" data-id="element-247">Initial investment:</p>
            <p className="font-bold text-xl" data-id="element-248">£59</p>
          </div>
          <div className="bg-blue-800 p-3 rounded-lg text-center" data-id="element-249">
            <p className="font-semibold text-sm mb-1" data-id="element-250">First year savings:</p>
            <p className="font-bold text-xl" data-id="element-251">£3,300</p>
          </div>
          <div className="bg-blue-800 p-3 rounded-lg text-center" data-id="element-252">
            <p className="font-semibold text-sm mb-1" data-id="element-253">ROI:</p>
            <p className="font-bold text-xl" data-id="element-254">Over 5000%</p>
          </div>
        </div>
        <blockquote className="italic border-l-4 border-white pl-4 py-2 text-center" data-id="element-255">
          "Show me any other investment with that kind of return," Dr. Grant
          challenges.
        </blockquote>
      </div>
    </section>;
};